import { render, staticRenderFns } from "./CardTitle.vue?vue&type=template&id=496837fb&scoped=true"
var script = {}
import style0 from "./CardTitle.vue?vue&type=style&index=0&id=496837fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496837fb",
  null
  
)

export default component.exports